//index.js
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import {
  Home,
  Resume,
  Contact,
  TypeTest,
  FourZeroFour,
} from "./components/App";
import { PageWorkFracturedVeil } from "./components/Pages/Work/FracturedVeil";
import { PageWorkKuaa } from "./components/Pages/Work/Kuaa";
import { PageWorkKlymit } from "./components/Pages/Work/Klymit";
import { PageWorkMcgee } from "./components/Pages/Work/Mcgee";
import { PageWorkOgg } from "./components/Pages/Work/Ogg";
import { PageWorkBlackDiamond } from "./components/Pages/Work/BlackDiamond";
import { PageWorkBlackDiamondS } from "./components/Pages/Work/BlackDiamondS";
import { PageWorkChapul } from "./components/Pages/Work/Chapul";
import { PageWorkLeaf } from "./components/Pages/Work/Leaf";
import { PageWorkManimal } from "./components/Pages/Work/Manimal";
import { PageWorkMbj } from "./components/Pages/Work/Mbj";
import { PageWorkOlympic } from "./components/Pages/Work/Olympic";
import { PageWorkSharpko } from "./components/Pages/Work/Sharpko";
import { PageWorkTucker } from "./components/Pages/Work/Tucker";
import { PageWorkPcg } from "./components/Pages/Work/Pcg";
import AppContainer from "./containers/AppContainer";
import withTracker from "./components/Partials/Tracker.js";

import "normalize.css"; // Note this

ReactDOM.render(
  <BrowserRouter>
    <AppContainer>
      <Switch>
        <Route exact path="/" component={withTracker(Home)} />
        <Route exact path="/t/:tag" component={Home} />
        <Route exact path="/work" component={withTracker(Home)} />
        <Route path="/resume" component={withTracker(Resume)} />
        <Route path="/contact" component={withTracker(Contact)} />
        <Route path="/test" component={withTracker(TypeTest)} />
        <Route
          path="/work/fracturedveil"
          component={withTracker(PageWorkFracturedVeil)}
        />
        <Route path="/work/kuaa" component={withTracker(PageWorkKuaa)} />
        <Route path="/work/klymit" component={withTracker(PageWorkKlymit)} />
        <Route path="/work/mcgee" component={withTracker(PageWorkMcgee)} />
        <Route path="/work/ogg" component={withTracker(PageWorkOgg)} />
        <Route
          path="/work/blackdiamond"
          component={withTracker(PageWorkBlackDiamond)}
        />
        <Route
          path="/work/blackdiamonds"
          component={withTracker(PageWorkBlackDiamondS)}
        />
        <Route path="/work/chapul" component={withTracker(PageWorkChapul)} />
        <Route path="/work/leaf" component={withTracker(PageWorkLeaf)} />
        <Route path="/work/manimal" component={withTracker(PageWorkManimal)} />
        <Route path="/work/mbj" component={withTracker(PageWorkMbj)} />
        <Route path="/work/olympic" component={withTracker(PageWorkOlympic)} />
        <Route path="/work/sharpko" component={withTracker(PageWorkSharpko)} />
        <Route path="/work/tucker" component={withTracker(PageWorkTucker)} />
        <Route path="/work/pcg" component={withTracker(PageWorkPcg)} />

        <Route component={withTracker(FourZeroFour)} />
      </Switch>
    </AppContainer>
  </BrowserRouter>,
  document.getElementById("app")
);



// WEBPACK FOOTER //
// ./src/index.js